<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" ref="customerTable" >
      <template slot="tableTopCustom" slot-scope="data">
        <div class="table-list-desc">当前大客户数量 {{form.formResult.total}} 人</div>
      </template>
    </wt-form-table>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_CUSTOMERINFO',
        formComponent: {
          view: { type: 'component', componentName: 'CustomerInfoView', value: 'queryUserMessageDetailData', noRequest: true },
          edit: { type: 'component', componentName: 'UserCustomerEdit', value: 'queryUserMessageDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/userWechat/userWechatList' },
          delete: { type: 'default', value: '/modules/userWechat/userWechatDelete' },
          customer: { componentName: 'UserCustomerPage' }
        },
        formInputsData: [
          { name: '搜索用户', key: 'keyWord', value: '', type: 'text' },
          { name: '注册时间', key: 'updateTimeRange', value: [], type: 'datetime' },
          { name: '客户类型', key: 'userType', value: 2, type: 'customAll' },
          { name: '社区', key: 'communityId', value: '', type: 'customAll' }],
        formButtonsData: [],
        formTableData: [
          { name: '大客户名称', key: 'name', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '注册时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '其他', key: 'otherInfo', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', hidden: false, className: 'primary', permission: 'VIEW' },
          { name: '编辑', key: 'EDIT', action: 'EDIT', hidden: false, className: 'primary', permission: 'EDIT' },
          { name: '删除', key: 'DELETECONFIRM', action: 'DELETECONFIRM', className: 'danger', hidden: false, permission: 'DELETE' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonMinWidth: 240, buttonWidth: 240 }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      console.log('data', data)
      const that = this
      if (data && data.item) {
        if (data.item.action === 'VIEW') {
          this.$store.dispatch('setUserWechatCustomerId', data.row.id)
          this.$store.dispatch('setUserWechatDetailData', JSON.parse(JSON.stringify(data.row)))
        }
        if (data.item.action === 'EDIT') {
          this.$store.dispatch('setUserWechatCustomerId', data.row.id)
          this.$store.dispatch('setUserWechatDetailData', JSON.parse(JSON.stringify(data.row)))
        }
        if (data.item.action === 'DELETECONFIRM') {
          this.$prompt('请输入登录密码', '确认删除提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'password',
            inputPattern: /\S/,
            inputErrorMessage: '登录密码不能为空'
          }).then(({ value }) => {
            request({
              url: this.form.formComponent.delete.value,
              method: 'post',
              data: {
                id: data.row.id,
                password: value
              }
            }).then(response => {
              that.$refs.customerTable.requestFormList()
              that.$message({ message: '删除成功', type: 'success' })
            }).catch(() => {})
          }).catch(() => {})
        }
      }
    }
  }
}
</script>
<style scoped>
.table-list-desc {
  padding: 20px;
  color: #333333;
  font-size: 14px;
}
</style>
